<template>
  <b-modal id="modal-acesso-rapido" data-backdrop="static" data-keyboard="false" centered
    :title="this.$t('Acesso Rápido')">

    <div v-for="(acesso, index) in arrayAcessos" :key="index">
      <button class="btn container divAcessoRapido" @click="loginRapido(acesso)">
        <p class="nomeAcessoRapido">{{ acesso.nome }}</p>
        <p>{{ acesso.matricula }} - {{ acesso.empresa }}</p>
      </button>
    </div>

    <template #modal-footer="{ cancel }">
      <div class="w-100">
        <div class="row center" style="justify-content: center;">
          <b-button class="mr-2" variant="danger" size="lg" @click="cancel()">
            {{ $t('Cancelar') }}
          </b-button>
        </div>
      </div>
    </template>
  </b-modal>
</template>
<script>

export default {
  name: "ModalExterna",
  props: {
  },
  data() {
    return {
      arrayAcessos: []
    };
  },
  created() {

  },

  computed: {

  },
  methods: {
    loginRapido(acesso) {
      this.$emit('acessoRapido', { ...acesso })
      this.$bvModal.hide('modal-acesso-rapido')
    },
    populaAcessos() {
      let array = JSON.parse(localStorage.getItem('acessoRapido')) || [];

      this.arrayAcessos = array
    }
  },

}
</script>
<style>
.divAcessoRapido {
  border-bottom: 1px solid #c5c5c5;
  padding-top: 10px;
  padding-left: 30px;
  text-align: left;
}

.nomeAcessoRapido {
  font-size: 20px;
  margin-bottom: 0px;
}
</style>